export default __webpack_public_path__ + "static/media/tick.55dd97c1.svg";